module.exports = __webpack_public_path__ + "img/gb2264.prt.4ba06607.jpg";